











































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CourseItem } from '@/resource/course-item/course-item.model';
import VuePdfApp from 'vue-pdf-app';
import VueYouTubeEmbed from 'vue-youtube-embed';
import MainButton from '@/main-components/common/MainButton.vue';
import QuestionLoading from '@/components/questions/QuestionLoading.vue';
import CourseItemExercise from '@/components/course/CourseItemExercise.vue';
import { ErrorResponse } from '@/utils/response';
Vue.use(VueYouTubeEmbed);

@Component({
  components: { VuePdfApp, MainButton, QuestionLoading, CourseItemExercise },
})
export default class CoursePurchasedContent extends Vue {
  @Prop({ required: true })
  courseItems: CourseItem[];

  @Prop({ required: true })
  courseProgress: number;

  isLoading = false;
  isDownloadPdfLoading = false;

  isPdfRendered = false;
  heightPapers = 10;
  pdfConfig = {
    toolbar: {},
  };

  get updatedCourseItems() {
    return this.courseItems;
  }

  async downloadPdfClick() {
    if (this.isDownloadPdfLoading) return;

    this.isDownloadPdfLoading = true;

    const currentCourseItem = this.updatedCourseItems[this.courseProgress];

    const pdfName = `${currentCourseItem.title}.pdf`;
    pdfName.replaceAll(' ', '_');

    let blob: Blob | null = null;

    try {
      blob = await fetch(currentCourseItem.pdfLink).then(r => r.blob());
    } catch (err) {
      const error: ErrorResponse = err as any;
      this.$toasted.global.mainToast({
        message: `ERROR: ${error.message}`,
      });
    }

    const url = window.URL.createObjectURL(blob as Blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', pdfName);
    document.body.appendChild(link);
    link.click();

    this.$toasted.global.mainToast({
      message: 'PDF paper downloaded',
    });

    this.isDownloadPdfLoading = false;
  }

  pagesRendered() {
    this.isPdfRendered = true;
    this.updatePdfHeight();
    window.addEventListener('resize', this.updatePdfHeight);
  }

  updatePdfHeight() {
    const pages = document.getElementsByClassName('page') || [];
    const currentHeight = pages && pages[0] && pages[0].scrollHeight;

    this.heightPapers = currentHeight * pages.length;
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.updatePdfHeight);
  }
}
